module.exports = __webpack_public_path__ + "img/add.4b450b35.svg";